(function () {
  // escape hatch
  if (!document.querySelector(".button, .button-custom")) return;

  // setup
  const allButtons = Array.from(
    document.querySelectorAll(".button[data-guid], .button-custom[data-guid]")
  );
  let clickedButtons =
    JSON.parse(window.localStorage.getItem(`jumboClickedButtons${WP.uid}`)) ||
    [];

  clickedButtons.forEach((button) => {
    const node = document.querySelector(
      `.button[data-guid="${button}"], .button-custom[data-guid="${button}"]`
    );
    if (node) setButtonDisplayClicked(node);
  });

  const spotlightBlocks = Array.from(
    document.querySelectorAll(".event-section-buttons[data-btn-size]")
  );

  spotlightBlocks.forEach((block) => {
    const size = block.dataset.btnSize;
    const spotlightItems = Array.from(
      block.querySelectorAll(".button--spotlight")
    );
    spotlightItems.forEach((item) => {
      setButtonSize(item, size);
    });
  });

  // events
  allButtons.forEach((button) => {
    // check that button has some interaction (email, text or image change)
    if (
      button.dataset.afterImageSrc != "" ||
      button.dataset.afterText != "" ||
      button.dataset.emailTemplate
    ) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        handleButtonClicked(button);
      });
    }
  });

  // functions
  function sendEmail(uid, recipients, template) {
    const endpoint = `${window.location.origin}/wp-json/jumbo/v1/send-email`;
    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": WP.nonce,
      },
      body: JSON.stringify({ uid, recipients, template }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        // handle transport error
        console.error("network/transport error sending email", error);
      });
  }

  function handleButtonClicked(btn) {
    setButtonDisplayClicked(btn);

    // update local storage
    if (clickedButtons.indexOf(btn.dataset.guid) === -1) {
      clickedButtons.push(btn.dataset.guid);
      window.localStorage.setItem(
        `jumboClickedButtons${WP.uid}`,
        JSON.stringify(clickedButtons)
      );
    }

    // if email button, send email
    if (btn.dataset.emailTemplate) {
      sendEmail(
        WP.uid,
        btn.dataset.recipients,
        parseInt(btn.dataset.emailTemplate)
      );
    }
  }

  function setButtonDisplayClicked(btn) {
    // update button style
    btn.classList.add("button--bright");

    // update button text
    if (btn.dataset.afterText)
      btn.querySelector(".button-label").textContent = btn.dataset.afterText;

    // update button image
    if (btn.dataset.afterImageSrc && btn.dataset.afterImageType) {
      const imgSpan = btn.querySelector(
        `.button-${btn.dataset.afterImageType}`
      );
      const newSrc = btn.dataset.afterImageSrc;
      if (newSrc.includes(".svg")) {
        fetch(newSrc)
          .then((response) => response.text())
          .then((str) =>
            new window.DOMParser().parseFromString(str, "text/xml")
          )
          .then((xmlDoc) => {
            let svg = xmlDoc.querySelector("svg");
            svg.removeAttribute("xmlns:a");
            imgSpan.innerHTML = "";
            imgSpan.appendChild(svg);
          });
      } else {
        imgSpan.innerHTML = `<img src=${newSrc}>`;
      }
    }
  }

  function setButtonSize(btn, size) {
    btn.style.width = `${size}px`;
  }
})();
